/**
 * @flow
 */

import styled, { css } from 'react-emotion'

import Colors from '../../../themes/Colors'

import { IcChevronDown, IcUsers } from '../../../Icons'
import {
  Typo13DarkGreyBlueRR,
  Typo14BlueyGrey3RR,
  Typo12DullRedRR
} from '../../../themes/Fonts'
import { desktop } from '../../../utils/mixins'

export const MainContainer = styled('div')`
  display: flex;
  flex-direction: column;
  @media (min-width: 992px) and (max-width: 1352px) {
    flex: 1;
  }
  @media (min-width: 992px) {
    flex: ${props => (props.isBhowaniporePresentInQueryParams ? 0.8 : 1)};
    min-width: ${props =>
      props.isBhowaniporePresentInQueryParams ? '120px' : 'auto'};
  }
  @media (min-width: 1025px) and (max-width: 1352px) {
    margin-right: ${props =>
      props.isBhowaniporePresentInQueryParams ? '10px' : null};
  }
  @media screen and (min-width: 1353px) {
    margin-right: ${props =>
      props.isBhowaniporePresentInQueryParams ? '25px' : null};
  }
`

export const DropdownLabel = styled(Typo13DarkGreyBlueRR)`
  margin-bottom: 3px;
  line-height: 1.428;
  color: ${props => {
    if (props.displayError) {
      return Colors.dullRed
    } else if (props.isMobile) {
      return Colors.whiteTwo
    }
    return Colors.darkGreyBlue
  }};
`

export const DropdownButton = styled('div')`
  display: flex;
  width: ${props =>
    props.isBhowaniporePresentInQueryParams ? '100%' : '220px'};
  position: relative;
  border-radius: 2px;
  background-color: ${Colors.iceBlue};
  border: solid 1px
    ${props => {
      if (props.expanded) {
        return Colors.lightNavyThree
      }
      return Colors.lightBlueGreyThree
    }};
  padding: 8px 12px 8px 12px;

  @media (min-width: 320px) and (max-width: 991px) {
    width: 280px;
  }
  @media (min-width: 992px) and (max-width: 1352px) {
    width: 100%;
  }
`

export const DropdownValue = styled(Typo14BlueyGrey3RR)`
  opacity: ${props => (props.expanded ? 1 : props.placeholder ? 0.9 : 0.6)};
  color: ${props => {
    if (props.expanded) {
      return Colors.twilightBlueTwo
    } else if (props.isMobile) {
      return Colors.blueyGreyThree
    }
    return Colors.charcoalGrey
  }};
`

export const DropdownLeftIcon = styled('div')`
  margin-right: 10px;
  user-select: none;
`

export const LeftIcon = styled(IcUsers)`
  object-fit: contain;
`

export const DropdownDownArrow = styled('div')`
  user-select: none;
  position: absolute;
  right: 17px;
  cursor: pointer;
  height: 20px;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const DownArrow = styled(IcChevronDown)`
  object-fit: contain;
`

export const DropdownOptionsContainer = styled('div')`
  overflow-x: auto;
  overflow-y: scroll;
  margin-top: 10px;
  padding: 10px 10px 10px 10px;
  height: ${props => (props.dropDownOptionsLength > 6 ? '259px' : 'auto')};
  border-radius: 2px;
  background-color: ${Colors.whiteTwo};
  box-shadow: 0 2px 6px 0 ${Colors.black20};
  @media (min-width: 320px) and (max-width: 425px) {
    width: 280px;
    height: ${props => (props.dropDownOptionsLength > 4 ? '200px' : 'auto')};
  }
  @media (min-width: 426px) and (max-width: 991px) {
    width: 280px;
  }
  ${desktop} {
    width: 220px;
  }
`

export const DropdownText = styled('div')`
  cursor: pointer;
  font-family: din-2014;
  font-size: 14px;
  color: ${Colors.charcoalGrey};
  padding: 12px 20px 12px 20px;
  &:hover {
    border-radius: 4px;
    background-color: ${Colors.twilightBlueTwo};
    color: ${Colors.whiteTwo};
  }
`

export const DropdownStyles = css`
  z-index: 10000;
  left: 0px;
  right: 0px;
`

export const DropdownError = styled(Typo12DullRedRR)`
  margin-top: 5px;
`

export const DropdownMainDivStyles = css`
  margin: 0px;
`



// WEBPACK FOOTER //
// ./src/components/IbcArcade/FormDropdown/styledComponents.js